"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const oxygen_config_1 = require("@8x8/oxygen-config");
const ToastWrapper_1 = __importDefault(require("./ToastWrapper"));
const ToastStack = styled_components_1.default.div.attrs(() => ({
    ...(0, oxygen_config_1.getTestAttributes)('TOAST_STACK'),
})) `
  ${ToastWrapper_1.default} {
    margin-bottom: ${({ theme }) => theme.stackMargin};
  }
`;
exports.default = ToastStack;
